import moment from "moment";
import { useEffect, useState } from "react";
import { formatSecondsIntoTimer } from "../helpers";
import { Helmet } from "react-helmet";

/**
 *
 * @returns {ReactElement} KronosTimer component
 */
export function KronosTimerString({
  startDateUTC,
  helmet = false,
}: KronosTimerType) {
  const [elapsed, setElapsed] = useState<number>();
  let refreshInterval: ReturnType<typeof setInterval> | null;

  useEffect(() => {
    clear();
    if (startDateUTC) {
      refreshElapsed();
      if (!refreshInterval) {
        refreshInterval = setInterval(refreshElapsed, 1000);
      }
    }

    return clear;
  }, [startDateUTC]);

  const clear = () => {
    setElapsed(0);
    if (refreshInterval) clearInterval(refreshInterval);
    refreshInterval = null;
  };

  const refreshElapsed = () => {
    const now = moment();
    const start = moment(startDateUTC);
    const diff = now.diff(start, "seconds");
    setElapsed(diff);
  };
  if (!startDateUTC || !elapsed) return <span>0:00:00</span>;

  const elapsedString = formatSecondsIntoTimer(elapsed);
  return (
    <span>
      {helmet ? (
        <Helmet defer={false}>
          <title>{elapsedString}</title>
        </Helmet>
      ) : (
        []
      )}
      {elapsedString}
    </span>
  );
}

type KronosTimerType = {
  startDateUTC?: string;
  helmet?: boolean;
};
